import { Pipe, PipeTransform } from '@angular/core';
import { ACTIONS } from '@pages/checkout-app/components/abtest/models';
@Pipe({
  name: 'disableABTestMenuAction',
  standalone: false,
})
export class DisableABTestMenuAction implements PipeTransform {
  transform(action: ACTIONS, data, testGroups): boolean {
    switch (action) {
      case ACTIONS.STOP:
        return !!data?.finishedAt;
      case ACTIONS.DUPLICATE:
        return testGroups.some((t) => !t?.data?.finishedAt);
    }
  }
}
